import requestAPI from './instance'

/**
 * @description Promise to get all clubs
 * @returns {Promise} The Promise object
 */
export const getClubs = async () => {
  return await requestAPI.get(`/launcher/clubs`)
}

/**
 * @description Promise to create a new club
 * @param {Object} values - The data for creating a new club
 * @returns {Promise} The Promise object
 */
export const createClub = async (values) => {
  return await requestAPI.post(`/launcher/clubs`, values)
}

/**
 * @description Promise to delete a club
 * @param {Object} values - The data for creating a new club
 * @returns {Promise} The Promise object
 */
export const deleteClub = async ({ clubId }) => {
  return await requestAPI.delete(`/launcher/clubs/${clubId}`)
}

/**
 * @description Promise to validate a club slug
 * @param {Object} values - The data for creating a new club
 * @returns {Promise} The Promise object
 */
export const validateSlug = async ({ slug }) => {
  return await requestAPI.post(`/launcher/validate/slug`, { slug })
}
